import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function NavBar({ onContactClick }) {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleContactClick = () => {
    setMenuOpen(false);
    if (onContactClick) {
      onContactClick();
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          ☰
        </button>
        <div className={`navbar-links ${menuOpen ? 'open' : ''}`}>
          <Link className="navbar-link" to="/">HOME</Link>
          <Link className="navbar-link" to="/portfolio">PORTFOLIO</Link>
          <Link className="navbar-link" to="/services">SERVICES</Link>
          <Link className="navbar-link" to="/globe">GLOBE</Link>
          <button type="button" className="navbar-link navbar-link-button" onClick={handleContactClick}>CONTACT</button>
          <Link className="navbar-link" to="/about">ABOUT</Link>
        </div>
      </div>
    </nav>
  );
}
